export default {
  '401': 'Authentication failed, unable to access system resources',
  '403': 'The current operation does not have permission',
  '404': 'Access resource does not exist',
  'default': 'Unknown system error, please feed back to the administrator'
}
